import { useState } from 'react';
import { Alert, Box, Button, Link, Modal, SpaceBetween } from '@amzn/awsui-components-core';

import { ContentValidationIssue } from '../v2-hooks/useSaveContent';

interface SaveErrorAlertProps {
  readonly errorMessage: string;
  readonly validationIssues?: readonly ContentValidationIssue[];
  readonly onDismiss: () => void;
}

/** Error alert for a failed save; when the failure is validation, links to a modal listing every issue. */
export function SaveErrorAlert({ errorMessage, validationIssues, onDismiss }: SaveErrorAlertProps) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  // Only validation failures carry a detailed list worth surfacing in a modal.
  const issues = validationIssues ?? [];
  const hasDetails = issues.length > 0;

  return (
    <>
      <Alert type="error" dismissible onDismiss={onDismiss}>
        {errorMessage}
        {hasDetails && (
          <>
            {' '}
            <Link variant="primary" onFollow={() => setIsDetailsOpen(true)}>
              View details
            </Link>
          </>
        )}
      </Alert>

      {hasDetails && (
        <Modal
          visible={isDetailsOpen}
          header="Validation issues"
          onDismiss={() => setIsDetailsOpen(false)}
          footer={
            <Box float="right">
              <Button variant="primary" onClick={() => setIsDetailsOpen(false)}>
                Close
              </Button>
            </Box>
          }
        >
          <SpaceBetween size="xs" direction="vertical">
            {issues.map((issue) => (
              <div key={`${issue.key}:${issue.value}`}>
                <Box variant="strong" display="inline">
                  {issue.key}:
                </Box>{' '}
                {issue.value}
              </div>
            ))}
          </SpaceBetween>
        </Modal>
      )}
    </>
  );
}
